import styled from 'styled-components';

export const StyledSignIn = styled.div`
  position: relative;

  .si-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 150px;

    &-left {
      width: 476px;
      max-height: 628px;
      padding: 75px 67px 47px;
      border-radius: 20px;
      background: linear-gradient(
        322.42deg,
        rgba(6, 163, 182, 0.78) -9.37%,
        rgba(11, 149, 195, 0.78) 50.91%,
        rgba(2, 36, 149, 0.78) 105.66%
      );

      &-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 42px;
        gap: 12px;

        > img {
          width: 50%;
        }
      }

      &-middle {
        .logo {
          margin-bottom: 14px;
        }
      }

      &-bottom {
        margin-top: 54px;

        &-top {
          margin-bottom: 22px;
          color: var(--color-white);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 28px;

          > span {
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
            color: var(--color-white);

            &:first-child {
              position: relative;

              &:after {
                content: '';
                position: absolute;
                right: -15px;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 12px;
                background: var(--color-white);
              }
            }
          }
        }

        &-middle {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          white-space: nowrap;
          color: var(--color-white);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          > span {
            color: var(--color-white);

            &:first-child {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
`;

export const StyledSignInRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  h1,
  h3,
  h5 {
    font-weight: 500;
    white-space: nowrap;
    color: white;
  }

  h1 {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 48px;
  }

  h3 {
    font-size: 32px;
  }

  h5 {
    font-size: 24px;
  }

  .middle {
    width: fit-content;
    margin-bottom: -10px;

    .flex {
      display: flex;
      gap: 16px;

      p {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 28px;
        margin-top: 22px;
        border-radius: 100px;
        background: #ffffffa3;
      }
    }
  }

  @media (max-width: 1280px) {
    display: none;
  }
`;
